import { Injectable } from '@angular/core';
import { TcsConfigurationService } from 'src/app/core/configuration.service';
import { TcsUserSettingsService } from 'src/lib/tcs-user-settings/tcs-user-settings.service';

// eslint-disable-next-line no-var
declare var enableConsoleLogging: boolean;
(window as any).enableConsoleLogging = false;

export interface LoggerOptions {
  cache?: false;
  console?: false;
  ngrxStore?: false;
  appInsights?: false;
  newRelic?: false;
}

export const loggerOptionsFactory = {
  cacheOnly: (): LoggerOptions => ({
    console: false,
    ngrxStore: false,
    appInsights: false,
    newRelic: false,
  }),
  consoleAndCacheOnly: (): LoggerOptions => ({
    ngrxStore: false,
    appInsights: false,
    newRelic: false,
  }),
};

@Injectable({
  providedIn: 'root',
})
export class LoggerOptionsService {
  constructor(
    private _tcsConfig: TcsConfigurationService,
    private _userSettings: TcsUserSettingsService,
  ) {}

  public canLogToCache(options?: LoggerOptions) {
    return options?.cache ?? this._userSettings.value.loggingCacheEnabled;
  }

  public canLogToConsole(options?: LoggerOptions) {
    return options?.console ?? (this._userSettings.value.loggingEnabled || enableConsoleLogging);
  }

  public canLogToNgrxStore(options?: LoggerOptions) {
    return options?.ngrxStore ?? true;
  }

  public canLogToAppInsights(options?: LoggerOptions) {
    return options?.appInsights ?? this._tcsConfig.value.logging.applicationInsights.enabled;
  }

  public canLogToNewRelic(options?: LoggerOptions) {
    return options?.newRelic ?? this._tcsConfig.value.logging.newRelic.enabled;
  }

  public isPubnubLoggingEnabled() {
    return this._tcsConfig.value.logging.pubnub.enabled;
  }
}
